export default (obj) => {
  Object.entries(obj).forEach(([prop, value]) => {
    if (!value || value === null) delete obj[prop];
  });

  return obj;
};
